if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        this.setRecentlyViewedProduct();
        this.setQueenSizeDefault();
      }

      setQueenSizeDefault() {
        const urlParams = new URLSearchParams(window.location.search);
        const queenSizeOption = this.querySelector('variant-selects input[type="radio"][value="Queen"]');
        if (!urlParams.has('variant') && queenSizeOption) {
          const inputDomId = queenSizeOption.getAttribute('id');
          const labelDom = this.querySelector(`variant-selects label[for="${inputDomId}"]`);
          if (labelDom) {
            labelDom.click();
            queenSizeOption.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }

      setRecentlyViewedProduct() {
        const key = '__recently_viewed_products__';
        const recentlyViewed = JSON.parse(localStorage.getItem(key)) || [];
        const currentProduct = this.querySelector('script#product-recently-viewed-data');
        if (!currentProduct) return;

        const productData = JSON.parse(currentProduct.innerHTML) || {};
        if (!productData.id) return;

        const index = recentlyViewed.findIndex(r_p => r_p.id === productData.id);

        // move to front if already in list
        if (index !== -1 && index !== 0) {
          recentlyViewed.splice(index, 1);
        }
        if (index !== 0) {
          recentlyViewed.unshift(productData);
        }

        if (recentlyViewed.length > 20) {
          recentlyViewed.pop();
        }
        localStorage.setItem(key, JSON.stringify(recentlyViewed));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        // productForm?.toggleSubmitButton(true);
        productForm && productForm.handleErrorMessage ? productForm.handleErrorMessage() : '';
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      updateMediaViaSkuFromAlt(html) {
        const media360 = document.querySelector('cylindo-viewer')
        if (!media360) {
          const mediaWrapper = html.querySelector('.product__media-wrapper')
          console.log('mediaWrapper', mediaWrapper);
          if (mediaWrapper) {
            HTMLUpdateUtility.viewTransition(this.querySelector('.product__media-wrapper'), mediaWrapper, this.preProcessHtmlCallbacks);
          }
        }
      }

      updateDescription(html) {
        const descriptionSource = html.querySelector('.variant-description');
        const descriptionDestinations = this.querySelectorAll('.variant-description');

        descriptionDestinations.forEach((descriptionDestination) => {
          if (descriptionSource && descriptionDestination) {
            descriptionDestination.innerHTML = descriptionSource.innerHTML;
          }
        });
      }

      updateVariantDetailsTable(html) {
        const detailsTableSource = html.querySelector('.section--product-info-table');
        const detailsTableDestination = this.querySelectorAll('.section--product-info-table');

        if (detailsTableSource && detailsTableDestination && detailsTableDestination.length > 0) {
          detailsTableDestination.forEach((destination) => {
            destination.innerHTML = detailsTableSource.innerHTML;
          });
        }
      }

      updateAdditionalInfoSection(html) {
        const additionalInfoSource = html.querySelector('.product-below-media-info__content.variant-dimensions');
        const additionalInfoDestination = this.querySelectorAll('.product-below-media-info__content.variant-dimensions');

        if (additionalInfoSource && additionalInfoDestination.length > 0) {
          additionalInfoDestination.forEach((destination) => {
            destination.innerHTML = additionalInfoSource.innerHTML;
          });
        }
      }

      updateStockMessage(html) {
        const stockMessageSource = html.querySelector('.product__stock');
        const stockMessageDestination = this.querySelector('.product__stock');

        if (stockMessageSource && stockMessageDestination) {
          stockMessageDestination.outerHTML = stockMessageSource.outerHTML;
        }

        const stockMessageSource2 = html.querySelector('product-form product-stock');
        const stockMessageDestination2 = this.querySelector('product-form product-stock');

        if (stockMessageSource2 && stockMessageDestination2) {
          stockMessageDestination2.outerHTML = stockMessageSource2.outerHTML;
        }
      }

      updataOutsideSection() {
        const url = window.location.href

        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            // update 'product-addtional-info' section
            const additionalInfoSource = html.querySelector(`section.section--pdp-additional-info`);
            const additionalInfoSection = document.querySelector(`section.section--pdp-additional-info`);

            if (additionalInfoSource && additionalInfoSection) {
              additionalInfoSection.innerHTML = additionalInfoSource.innerHTML;
            }
          });
      }

      updateBreadcrumb(html) {
        const sourceSku = html.querySelector('.product-breadcrmb');
        const destinationSku = this.querySelector('.product-breadcrmb');
        if (sourceSku && destinationSku) {
          destinationSku.innerHTML = sourceSku.innerHTML;
        }
      }

      updateTitle(html) {
        const titleSource = html.querySelector('.product__title');
        const titleDestinations = this.querySelectorAll('.product__title');

        titleDestinations.forEach((titleDestination) => {
          if (titleSource && titleDestination) {
            titleDestination.innerHTML = titleSource.innerHTML;
          }
        });
      }

      updatePdpShippingMethods(html) {
        const shippingMethodsSource = html.querySelector('pdp-shipping-methods');
        const shippingMethodsDestination = this.querySelector('pdp-shipping-methods');

        if (shippingMethodsSource && shippingMethodsDestination) {
          shippingMethodsDestination.outerHTML = shippingMethodsSource.outerHTML;
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability.update ? this.pickupAvailability.update(variant) : null;
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          // replace this function
          // this.updateMedia(html, variant?.featured_media?.id);
          // filter product media alt via variant sku
          this.updateMediaViaSkuFromAlt(html)
          this.updateDescription(html);
          this.updateTitle(html);
          this.updateVariantDetailsTable(html);
          this.updateAdditionalInfoSection(html);
          this.updatePdpShippingMethods(html);
          this.updateBreadcrumb(html)
          // this.updataOutsideSection()

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          // this.productForm?.toggleSubmitButton(
          //   html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
          //   window.variantStrings.soldOut
          // );
          
          // update variant stock status by variant metafield location info
          // It's done by stock component in product-form.js
          // let stockStatus = false
          // if (html.querySelector('product-stock')) {
          //   stockStatus = html.querySelector('product-stock')?.getAttribute('data-stock') === 'Y';
          // }
          // this.productForm?.toggleSubmitButton(!stockStatus, window.variantStrings.soldOut);
          this.updateStockMessage(html)
          
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        if (this.querySelector('share-button') && this.querySelector('share-button').updateUrl) {
          this.querySelector('share-button')?.updateUrl(
            `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
          );
        }

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

if (!customElements.get('cross-sell-products-variant-select')) {
  customElements.define(
    'cross-sell-products-variant-select',
    class CrossSellProductsVariantSelect extends HTMLElement {
      connectedCallback() {
        this.querySelector('select')?.addEventListener('change', this.handleVariantChange.bind(this));
      }

      handleVariantChange(event) {
        const selectedVariantId = event.target.value;
        if (!selectedVariantId) return;

        const productItemDom = this.closest('.pdp-cross-sell-products__item');
        if (!productItemDom) return;

        // update data-selected-variant-id attribute on checkbox input
        const checkboxInput = productItemDom.querySelector('.pdp-cross-sell-products__checkbox');
        if (checkboxInput) {
          checkboxInput.setAttribute('data-selected-variant-id', selectedVariantId);
        }

        const storePriceItems = productItemDom.querySelectorAll('store-price');

        if (storePriceItems) {
          storePriceItems.forEach((storePriceItem) => {
            const storePriceVariantId = storePriceItem.getAttribute('data-variant-id');

            if (storePriceVariantId === selectedVariantId) {
              storePriceItem.classList.remove('hidden');
            } else {
              storePriceItem.classList.add('hidden');
            }
          });
        }
        
      }
    }
  );
}

if (!customElements.get('custom-jump-out-variant-picker')) {
  class CustomJumpOutVariantPicker extends HTMLElement {
    constructor() {
      super();

      this.onVariantChangeUnsubscriber = undefined
    }

    connectedCallback() {
      this.onVariantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.optionValueSelectionChange,
        this.handleBuildInVariantChange.bind(this)
      );
    }

    handleBuildInVariantChange({ data: { event, target, selectedOptionsNameValues } }) {
      console.log('handleBuildInVariantChange in custom jump out variant picker', selectedOptionsNameValues);
      const jumpOutVariantPickers = this.querySelectorAll('.variant-item:not(.active');

      if (!jumpOutVariantPickers) return;

      for (let i = 0; i < jumpOutVariantPickers.length; i++) {
        const jumpOutVariantPicker = jumpOutVariantPickers[i];
        try {
          const optionNameValues = JSON.parse(jumpOutVariantPicker.dataset.variants);
          if (!Array.isArray(optionNameValues)) continue;

          let matchedVariant = optionNameValues.find(optionNameValue => {
            if (Array.isArray(optionNameValue.options) && optionNameValue.options.length === selectedOptionsNameValues.length) {
              
              console.log(optionNameValue.options,  optionNameValue.options.every(option => {
                return selectedOptionsNameValues.find(selectedOptionsNameValue => selectedOptionsNameValue === option)
              }));
              return optionNameValue.options.every(option => {
                return selectedOptionsNameValues.find(selectedOptionsNameValue => selectedOptionsNameValue === option)
              });
            }
            return false;
          })
          
          if (matchedVariant) {
            const baseHref = jumpOutVariantPicker.dataset.baseHref;

            jumpOutVariantPicker.href = `${baseHref}?${new URLSearchParams({ variant: matchedVariant.id }).toString()}`;
          }
        } catch (e) {
          console.error('Error parsing data-variants for jump out variant picker', e);
        }
      }
    }

    disconnectedCallback() {
      this.onVariantChangeUnsubscriber();
    }
  }

  customElements.define('custom-jump-out-variant-picker', CustomJumpOutVariantPicker); 
}